(ns web3.tracking.ga
  (:require [web3.env :as env]
            [kitchen-async.promise :as p]
            [applied-science.js-interop :as j]
            [web3.log :as log])
  (:require-macros [cljs.core.async.macros :refer [go go-loop]]))

(def GOOGLE_ANALYTICS_ID (env/config :GOOGLE_ANALYTICS_ID nil))

(defn gtag
  [& args]
  (when-let [gtag (j/get js/window :gtag)]
    (apply gtag args)
    true))

(defn tracker
  []
  (some-> (j/get js/window :ga)
          (.getAll)
          (first)))

(defn config!
  [params]
  (gtag "config" GOOGLE_ANALYTICS_ID (clj->js params)))

(defn event!
  ([action] (event! action {}))
  ([action params]
   (when GOOGLE_ANALYTICS_ID
     (p/race [(p/timeout 1000)
              (p/promise [resolve reject]
                (gtag "event" action
                      (-> params
                          (assoc "event_callback" #(resolve true))
                          (clj->js))))]))))

(defn pageview!
  [{:keys [path referrer]}]
  (->> {"page_path" path
        "linker" {"domains" [(env/config :MARKETING_HOSTNAME)
                             (j/get-in js/window [:location :hostname])
                             (or
                              (env/config :AUTH0_DOMAIN)
                              (env/config :OKTA_ISSUER))]}}
       (merge (when (seq referrer)
                {"page_referrer" referrer}))
       (config!)))
